import { render } from "./CategoryField.vue?vue&type=template&id=07cb74be&scoped=true"
import script from "./CategoryField.vue?vue&type=script&lang=js"
export * from "./CategoryField.vue?vue&type=script&lang=js"

import "./CategoryField.vue?vue&type=style&index=0&id=07cb74be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cb74be"]])

export default __exports__